import { useEffect, useRef, useState } from 'react';
import { Input } from '../../../../../components/Basic/Inputs';
import styles from './styles.module.scss';

const RealQuantityInput = ({ product = {}, onsSave = () => { }, onChangeProduct = () => { }, ...props }) => {
  const [real_quantity, setRealQuantity] = useState(0);
  const [openInput, setInput] = useState(false);

  const save = (v) => {
    setRealQuantity(v)
    setInput(false);
    onChangeProduct(v);
  };
  const ref = useRef(null);

  useEffect(() => {
    setRealQuantity(product.real_quantity);
  }, [product.real_quantity]);
  return openInput ? (
    <>
      <Input
        value={real_quantity}
        style={{ width: '80%' }}
        onClickEnter={(v) => save(v)}
        onBlur={(v) => save(v)}
        autoFocus={true}
        ref={ref}
        center={true}
        fontSize={17}
        className={styles.input_name}
      />
      <div className={styles.num}>/ {product.common_quantity || 0}</div>{' '}
    </>
  ) : (
    <div className={styles.num} onClick={() => setInput(true)}>
      {real_quantity === product.common_quantity ? (
        <>{product.common_quantity || 0}</>
      ) : (
        <>
          {real_quantity || 0}{' '}
          <span style={{ fontWeight: '400', fontSize: '20px' }}>/ {product.common_quantity || 0}</span>
        </>
      )}
    </div>
  );
};

export default RealQuantityInput;
